import {
  SET_STORAGE_EXPECTED_INCOME,
  SET_STORAGE_EXPECTED_FIRST_CHARGE,
  CLEAR_STORAGE_EXPECTED_INCOME,
} from "./types";

const initialState = {
  expectedIncome: [],
  expectedFirstCharge: [],
};

export const storageExpectedIncomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STORAGE_EXPECTED_INCOME:
      return {
        ...state,
        expectedIncome: action.data,
      };
    case SET_STORAGE_EXPECTED_FIRST_CHARGE:
      return {
        ...state,
        expectedFirstCharge: action.data,
      };
    case CLEAR_STORAGE_EXPECTED_INCOME:
      return initialState;
    default:
      return state;
  }
};

